module.exports = __webpack_public_path__ + "static/media/eclipse-alt.62aef77b.svg";